import React from 'react'

const CustomToolTip = ({ active, payload }) => {   
    if (active && payload && payload.length) {
        const data = payload[0].payload; 
        return (
            <div className="custom-horizontal-chart-tooltip">
                <p>{data.name}</p>
                <p>{`Value: ${data.value}`}</p>
            </div>
          );
    }  
    return null
  };

  export default CustomToolTip;